import './ToggleBtn.less';

import React, { FC, MouseEventHandler } from 'react';
import clsx from 'clsx';
import { SvgIcon } from '../../../icons/SvgIcon';
import i18n from '../../../common/i18n';
import { isMobileChannel } from '../../../common/util';

export const ToggleContainer: FC<{ children: any }> = ({ children }) => (
    <div className="toggle-container">{children}</div>
);

interface ToggleButtonProps {
    imgId: string;
    active: boolean;
    onClick: MouseEventHandler<HTMLButtonElement>;
    badge?: number;
    titleKey?: string;
    otherClass?: string;
    'data-atid'?: string;
}

const ToggleBtn = ({
    imgId,
    active,
    onClick,
    badge,
    titleKey,
    otherClass,
    'data-atid': dataAtid
}: ToggleButtonProps) => {
    const title = titleKey && i18n(titleKey);
    return (
        <button
            onClick={onClick}
            title={title}
            className={clsx('px-5 fs-0 py-2', otherClass, { 'p-rel': badge })}
            data-atid={dataAtid}
        >
            <SvgIcon
                imgId={imgId}
                sizeX="22"
                sizeY="14"
                className={active && !isMobileChannel() ? 'c-orange' : 'match-icon'}
            />
            {badge && <span className="p-abs text-extra-bold c-white toggle-btn-badge">{badge}</span>}
        </button>
    );
};

export default ToggleBtn;
